export default __webpack_public_path__ + "static/media/ai-art-creator.7df2cfa7.png";